// src/services/organizationService.js

import axios from "axios";
import { API_URL } from "../config/apiConfig";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});


// Updates the current user's organization settings
// data = { name, timeZone, defaultStartTime, defaultEndTime }
export async function updateOrganizationSettings(data) {
  const response = await api.patch("/api/organizations/update", data);
  return response.data;
}

// Get current user's organization details
export async function getOrganizationDetails() {
  const response = await api.get("/api/organizations");
  // getAllOrganizations returns an array with the user's organization
  return response.data[0]; // Return the first (and only) organization
}

export async function getOrgInfo(orgId) {
  // you can do GET /api/orgs/:orgId or custom route
  const res = await api.get(`/api/organizations/${orgId}`);
  return res.data;
}

export async function removeUserFromOrg(orgId, userId) {
  // e.g. DELETE /api/orgs/:orgId/user/:userId
  const res = await api.delete(`/api/organizations/${orgId}/user/${userId}`);
  return res.data;
}

export async function updateUserRoleInOrg(orgId, userId, newRole) {
  // e.g. PATCH /api/orgs/:orgId/user/:userId
  const res = await api.patch(`/api/organizations/${orgId}/user/${userId}`, { role: newRole });
  return res.data;
}

// Create organization for current user
export async function createOrganizationForUser(data) {
  const response = await api.post("/api/organizations/create-for-user", data);
  return response.data;
}

// Update billing address for organization
export async function updateBillingAddress(organizationId, billingAddress) {
  const response = await api.patch(`/api/organizations/${organizationId}/billing-address`, {
    billingAddress
  });
  return response.data;
}
